export * from './controlGroup.component';
export * from './controlGroup.service';



// WEBPACK FOOTER //
// ./src/app/ControlGroup/index.ts